<template>
<!--ACCIDENT FORM-->
    <div>

<!--TITLE---------------------------------------------------->
            <div class="col-xs-12">
                <el-form-item label="Report Title:" prop="Title">
                    <el-input 
                        v-model="myController.Incident.Title" 
                        :maxlength="30" 
                        placeholder="Enter Report Title">
                    </el-input>
                </el-form-item>
            </div>

        <!--PREPARED BY---------------------------------------------->
            <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <el-form-item label="Report Prepared By:" prop="AddedBy">
                    <el-select 
                        placeholder=" Select Staff Member" 
                        style="width: 100%;" 
                        v-model="myController.Incident.AddedBy">
                        <el-option 
                            v-for="item in myController.staffmembers" 
                            :key="item.Id" 
                            :label="item.Name" 
                            :value="item.Id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>

            <!--OTHER PREPARER JUST XS - OTHER PREPARER IS ALONE ON THE LINE-->
            <span class="hidden-sm hidden-md hidden-lg hidden-xl"  v-if="myController.Incident.AddedBy=='0'" >
                <div class="col-xs-12">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-model="myController.Incident.ReportPreparedByOther" 
                            :maxlength="150" 
                            placeholder="Enter other report prepared by types">
                        </el-input>
                    </el-form-item>
                </div>
            </span>
            <!--END OF LINE FOR OTHER PREPARER ON XS DEVICE-->

            <!--POSITION-->
            <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3 ">
                <el-form-item label="Position:" prop="Position">
                    <el-select 
                        placeholder="Select preparer position" 
                        style="width: 100%;" 
                        v-model="myController.Incident.PositionId">
                        <el-option 
                            v-for="item in myController.roles" 
                            :key="item.PositionId" 
                            :label="item.PositionName"
                            :value="item.PositionId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>

            <!------------------------------------------------------------------------------
                OTHER PREPARER FOR ONLY SM (LINE HAs OTHER PREPARER AND PLACEHOLDER FOR
                POSITION
            ------------------------------------------------------------------------------->
            <span class="hidden-xs hidden-md hidden-lg hidden-xl"  v-if="myController.Incident.AddedBy=='0'" >
                <div class="col-sm-6">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-model="myController.Incident.ReportPreparedByOther" 
                            :maxlength="150" 
                            placeholder="Enter other report prepared by types">
                        </el-input>
                    </el-form-item>
                </div>
		        <!--PLACEHOLDER FOR POSITION-->
                <div class="col-sm-6">
                    <hydroware-other-input-placeholder/>
                </div>
            </span>
            <!--------------------------------------------------------------------------------
               END OF LINE FOR SM DEVICE WHEN OTHER PREPARER IS DISPLAYED
            --------------------------------------------------------------------------------->

            <!--PREPARED DATE-->
            <!--For consistency and for ease of responsiveness I got rid of the checkbox for todays date-->
            <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <el-form-item label="Report Date:"  prop="AddedOn">
                    <el-date-picker 
                        @blur=hydroware_picker_hasBlurred
                        type="date" 
                        format="MM-dd-yyyy" 
                        placeholder="Pick a date" 
                        style="width: 100%;"
                        v-model="myController.Incident.AddedOn">
                    </el-date-picker>
                </el-form-item>
            </div>
            <!--PREPARED TIME-->
            <!--For consistency and for ease of responsiveness I got rid of the checkbox for todays date-->
            <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <el-form-item label="Report Time:"  prop="AddedOn">
                    <el-time-picker 
                        :value-format="myController.$hydrowareCommonJS.hydrowareTimePickerFormat"
                        :format="myController.$hydrowareCommonJS.hydrowareTimePickerFormat"
                        :placeholder="myController.$hydrowareCommonJS.hydrowareTimePickerPlaceholder"
                        style="width: 100%;"
                        v-model="myController.Incident.AddOnTime">
                    </el-time-picker>
                </el-form-item>
            </div>

            <!------------------------------------------------------------------------------
                OTHER PREPARER bigger than SM (LINE HAD OTHER PREPARER AND PLACEHOLDERS FOR
                POSITION, DATE, AND TIME
            ------------------------------------------------------------------------------->
            <span class="hidden-xs hidden-sm "  v-if="myController.Incident.AddedBy=='0'" >
                <!--OTHER PREPARER-->
                <div class="col-md-3">
                    <el-form-item class="hydroware-other">
                        <el-input
                            v-bind:class="{'hydroware-ishidden': myController.Incident.AddedBy!=='0'}" 
                            v-model="myController.Incident.ReportPreparedByOther" 
                            :maxlength="150" 
                            placeholder="Enter other report prepared by types">
                        </el-input>
                    </el-form-item>
                </div>
                <!--PLACEHOLDER FOR POSITION-->
                <div class="col-md-3">
                    <hydroware-other-input-placeholder/>
                </div>
                <!--PLACEHOLDER FOR DATE-->
                <div class="col-md-3">
                    <hydroware-other-input-placeholder/>
                </div>
		        <!--PLACEHOLDER FOR TIME-->
                <div class="col-md-3">
                    <hydroware-other-input-placeholder/>
                </div>
            </span>
            <!------------------------------------------------------------------------------------
            END OF LINE WHEN DEVICE IS MD, LG, XL AND THERE IS AN OTHER PREPARER TO DISPLAY
            -------------------------------------------------------------------------------------->


            <!--VENUE----------------------------------------------------------------->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <el-form-item label="Venue:" >
                    <el-select 
                        placeholder="Select Aquatic Venue" 
                        style="width: 100%;" 
                        v-model="myController.PoolIdEdit">
                        <el-option v-for="item in myController.pools" 
                            :key="item.PoolId" 
                            :label="item.PoolName"
                            :value="item.PoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>

            <!--LOCATION-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <el-form-item label="Location:" prop="Location">
                    <el-input 
                        v-model="myController.Incident.LocationText" 
                        :maxlength="60" 
                        placeholder="Where did accident occur">
                    </el-input>
                </el-form-item>
            </div>
            <!--ACCIDENT DATE-----------------------------------------------------------> 
            <div class="col-xs-12 col-sm-3">
                <el-form-item label="Accident Date:" prop="AccidentDate">
                    <el-date-picker
                        @blur=hydroware_picker_hasBlurred 
                        type="date" 
                        format="MM-dd-yyyy" 
                        placeholder="Pick a date" 
                        style="width: 100%;"
                        v-model="myController.Incident.IncidentDate">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="col-xs-12 col-sm-3">
                <el-form-item label="Accident Time:" prop="AccidentTime" >
                    <el-time-picker 
                        :value-format="myController.$hydrowareCommonJS.hydrowareTimePickerFormat"
                        :format="myController.$hydrowareCommonJS.hydrowareTimePickerFormat"
                        :placeholder="myController.$hydrowareCommonJS.hydrowareTimePickerPlaceholder"
                        style="width: 100%;"
                        v-model="myController.Incident.IncidentTime">
                    </el-time-picker>
                </el-form-item>
            </div>        
            <!--ACCIDENT TYPE-->
            <div class="col-xs-12 col-sm-3">
                <el-form-item label="Accident Type:" prop="PoolType"> <!--FG - FOOF - NOT MY PROP NAME -->
                    <el-select 
                        placeholder="Select Accident Type" 
                        style="width: 100%;" 
                        v-model="myController.Incident.PoolType">
                        <el-option 
                            v-for="item in myController.AccidentTypes" 
                            :key="item" 
                            :label="item" 
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!--OTHER TYPE for XS display-->
            <span class="hidden-sm hidden-md hidden-lg hidden-xl"  v-if="myController.Incident.PoolType=='Other'">
                <div class="col-xs-12 col-sm-3">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-model="myController.Incident.OtherTypeIncident" 
                            :maxlength="150" 
                            placeholder="Enter other accident types">
                        </el-input>
                    </el-form-item>
                </div>
            </span>
            <!--SEVERITY-->
            <div class="col-xs-12 col-sm-3">
                <el-form-item label="Acc. Severity:" prop="Severity">
                    <el-select 
                        placeholder="Select Accident Severity" 
                        style="width: 100%;" 
                        v-model="myController.Incident.Severity">
                        <el-option 
                            v-for="item in myController.Severitys" 
                            :key="item" 
                            :label="item" 
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!--OTHER TYPE for displays bigger than XS-->
            <span class="hidden-xs"  v-if="myController.Incident.PoolType=='Other'">
                <div class="col-xs-12 col-sm-3"><hydroware-other-input-placeholder/></div>
                <div class="col-xs-12 col-sm-3"><hydroware-other-input-placeholder/></div>
                <div class="col-xs-12 col-sm-3">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-bind:class="{'hydroware-ishidden': myController.Incident.PoolType!=='Other'}"
                            v-model="myController.Incident.OtherTypeIncident" 
                            :maxlength="150" 
                            placeholder="Enter other accident type">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="col-xs-12 col-sm-3"><hydroware-other-input-placeholder/></div>
            </span>

            <div class="col-xs-12 col-sm-6">
                <el-form-item 
                    label="Contributing Factor:"
                    prop="BehaviorType">
                    <el-select 
                        placeholder="Select a factor" 
                        style="width: 100%;" 
                        v-model="myController.Incident.BehaviorType">
                        <el-option 
                            v-for="item in myController.AccidentBehavior" 
                            :key="item" 
                            :label="item" 
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>

            <!--OTHER FACTOR FOR XS-->
            <span class="hidden-sm hidden-md hidden-lg hidden-xl">
            <div class="col-xs-12" v-if="myController.Incident.BehaviorType=='Other'">
                <el-form-item class="hydroware-other">
                        <el-input 
                            placeholder="Enter factor" 
                            v-model="myController.Incident.OtherTypeBehavior" 
                            :maxlength="150" >
                        </el-input>
                    </el-form-item>
            </div>
            </span>
            <!--END OTHER FACTOR FOR XS-->

            <div class="col-xs-12 col-sm-6">
                <el-form-item label="Description:" prop="Description">
                    <el-input type="textarea"  
                        class="hydroware-no-resize-textarea"
                        placeholder="Describe the accident" 
                        v-model="myController.Incident.Description" 
                        :rows=2 
                        :maxlength="400">
                    </el-input>
                </el-form-item>
            </div>
            <!--OTHER FACTOR FOR LARGER THAN XS-->
            <span class="hidden-xs"  v-if="myController.Incident.BehaviorType=='Other'">
                <div class="col-sm-6">
                    <el-form-item class="hydroware-other" style="margin-top:-36px">
                        <el-input 
                            placeholder="Enter factor" 
                            v-model="myController.Incident.OtherTypeBehavior" 
                            :maxlength="150" >
                        </el-input>
                    </el-form-item>
                </div>
                <!--PLACEHOLDER FOR TIME-->
                <div class="col-sm-6">
                    <hydroware-other-input-placeholder/>
                </div>
            </span>
            <!--END OTHER FACTOR FOR LARGER THAN XS-->

<!-------------DOING THE LINE BELOW -->
<div class="col-xs-12 col-sm-4 col-lg-4 col-md-4">
                <el-form-item label="Victim:" prop="ViolatorClass">
                    <el-select 
                        placeholder="Select victim type" 
                        style="width: 100%;" 
                        v-model="myController.Incident.ViolatorClass">
                        <el-option 
                            v-for="item in myController.Violator" 
                            :key="item" 
                            :label="item" 
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>


 <span class="hidden-sm hidden-md hidden-lg hidden-xl">
            <div class="col-xs-12 hidden-sm hidden-md hidden-lg hidden-xl" v-if="myController.Incident.ViolatorClass=='Other'">
                <el-form-item class="hydroware-other">
                    <el-input 
                        v-model="myController.Incident.ViolatorOther" 
                        :maxlength="150" 
                        placeholder="Enter other victim types">
                    </el-input>
                </el-form-item>
            </div>
</span>



<div class="col-xs-12 col-sm-4 col-lg-4 col-md-4">
                <el-form-item label="Injury Type:" prop="InjuryType">
                    <el-select 
                        placeholder="Select Injury Type" 
                        style="width: 100%;" 
                        v-model="myController.Incident.InjuryType">
                        <el-option 
                            v-for="item in myController.injuryType" 
                            :key="item" 
                            :label="item" 
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
        <span class="hidden-sm hidden-md hidden-lg hidden-xl">
            <div class="col-xs-12" v-if="myController.Incident.InjuryType=='Other'">
                <el-form-item class="hydroware-other" >
                    <el-input 
                        v-model="myController.Incident.OtherInjuries" 
                        :maxlength="150" 
                        placeholder="Enter Injury Details">
                    </el-input>
                </el-form-item>
            </div>
        </span>

<div class="col-xs-12 col-sm-4 col-lg-4 col-md-4">
                <el-form-item label="Injury:" prop="Injury">
                    <el-input type="textarea" 
                        class="hydroware-no-resize-textarea"
                        v-model="myController.Incident.Injury" 
                        :rows=2 
                        :maxlength="400" 
                        placeholder="Enter Injury Details">
                    </el-input>
                </el-form-item>
            </div>


<!--Other Victim -- ----- -->
<span class="hidden-xs" 
    v-if="myController.Incident.ViolatorClass=='Other' || myController.Incident.InjuryType=='Other'">
            <div class="col-sm-4" v-if="myController.Incident.ViolatorClass=='Other'">
                <el-form-item class="hydroware-other"  style="margin-top:-36px">
                    <el-input 
                        v-model="myController.Incident.ViolatorOther" 
                        :maxlength="150" 
                        placeholder="Enter other victim types">
                    </el-input>
                </el-form-item>
            </div>
            <div class="col-sm-4" v-if="myController.Incident.InjuryType=='Other'">
                <el-form-item class="hydroware-other"  style="margin-top:-36px">
                    <el-input 
                        v-model="myController.Incident.OtherInjuries" 
                        :maxlength="150" 
                        placeholder="Enter Injury Details">
                    </el-input>
                </el-form-item>
            </div>
            <div class="col-sm-4">
                    <hydroware-other-input-placeholder/>
                </div>
</span>
<div class="col-xs-12 col-sm-6">
                <el-form-item label="Manager on duty:" prop="Supervisor">
                    <el-select 
                        placeholder="Select staff member" 
                        style="width: 100%;" 
                        v-model="myController.Incident.Supervisor">
                        <el-option 
                            v-for="item in myController.staffmembers" 
                            :key="item.Id" 
                            :label="item.Name" 
                            :value="item.Id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
<div class="col-xs-12 hidden-sm hidden-md hidden-lg hidden-xl" 
                v-if="myController.Incident.Supervisor=='0'">
                <el-form-item class="hydroware-other">
                    <el-input 
                        v-model="myController.Incident.ManagerOnDutyOther " 
                        :maxlength="150" 
                        placeholder="Enter manager on duty">
                    </el-input>
                </el-form-item>
            </div>
<div class="col-xs-12 col-sm-6">
                <el-form-item label="Location:" prop="SupervisorLocation">
                    <el-input 
                        v-model="myController.Incident.SupervisorLocation" 
                        :maxlength="30" 
                        placeholder="Enter manager location">
                    </el-input>
                </el-form-item>
            </div>
            <span class="hidden-xs" 
            v-if="myController.Incident.Supervisor=='0'">
            <div class="col-sm-6">
                <el-form-item class="hydroware-other">
                    <el-input 
                        v-model="myController.Incident.ManagerOnDutyOther " 
                        :maxlength="150" 
                        placeholder="Enter manager on duty">
                    </el-input>
                </el-form-item>
            </div>
            <div class="col-sm-6">
                    <hydroware-other-input-placeholder/>
            </div>
            </span>
             

<!--LIFEGUARD AND LIFEGUARD LOCATION-->
            <div class="col-xs-12 col-sm-6">
                <el-form-item label="Lifeguard:" prop="Lifeguard">
                    <el-select 
                        placeholder="Select responding lifeguard" 
                        style="width: 100%;" 
                        v-model="myController.Incident.Lifeguard">
                        <el-option 
                            v-for="item in myController.staffmembers" 
                            :key="item.Id" 
                            :label="item.Name" 
                            :value="item.Id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="col-xs-12 hidden-sm hidden-md hidden-lg hidden-xl" 
                v-if="myController.Incident.Lifeguard=='0'">
                <el-form-item class="hydroware-other">
                    <el-input 
                        v-model="myController.Incident.ManagerOnDutyOther" 
                        :maxlength="150" 
                        placeholder="Enter lifeguard types">
                    </el-input>
                </el-form-item>
            </div>
            <div class="col-xs-12 col-sm-6">
                <el-form-item label="Location:" prop="LifeguardLocation">
                    <el-input 
                        v-model="myController.Incident.LifeguardLocation" 
                        :maxlength="30"
                        placeholder="Enter Lifeguard Location">
                    </el-input>
                </el-form-item>
            </div>
            <span class=hidden-xs v-if="myController.Incident.Lifeguard=='0'">
                <div class="col-sm-6">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-model="myController.Incident.ManagerOnDutyOther" 
                            :maxlength="150" 
                            placeholder="Enter lifeguard typesssss">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="col-sm-6">
                    <hydroware-other-input-placeholder/>
                </div>
            </span>


<!--POLICE------------------------------------------------------------------>
            <div class="col-xs-12 col-sm-4">
                <el-form-item label="Police:" prop="Police">
                    <el-checkbox 
                        v-model="myController.Incident.Police">
                    </el-checkbox>
                </el-form-item>
                <!--POLICE EXTRA INFO FOR XS-->
                <el-form-item
                     class="hydroware-other-checkbox hidden-sm hidden-md hidden-lg hidden-xl"  
                    prop="PoliceCase" 
                    v-if="myController.Incident.Police">
                    <el-input 
                        v-model="myController.Incident.PoliceCase" 
                        :maxlength="30" 
                        placeholder=" Enter Police Dept. Case">
                    </el-input>
                </el-form-item>
            </div>
            <!--FIRE DEPARTMENT-->
            <div class="col-xs-12 col-sm-4">
                <el-form-item label="Fire Department:" prop="FireDepartment">
                    <el-checkbox 
                        v-model="myController.Incident.FireDepartment">
                    </el-checkbox>
                </el-form-item>
                <!--FIRE DEPT EXTRA INFO FOR XS-->
                <el-form-item 
                     class="hydroware-other-checkbox hidden-sm hidden-md hidden-lg hidden-xl" 
                    prop="FireDepartmentCase" 
                    v-if="myController.Incident.FireDepartment">
                    <el-input 
                        v-model="myController.Incident.FireDepartmentCase" 
                        :maxlength="30" 
                        placeholder="Enter Fire Dept. Case">
                    </el-input>
                </el-form-item>
            </div>
            <!--EMS-->
            <div class="col-xs-12 col-sm-4">
                <el-form-item label="EMS:" prop="lastname">
                    <el-checkbox 
                        v-model="myController.Incident.EMS">
                    </el-checkbox>
                </el-form-item>
                <!--EMS Extra Info FOR XS-->
                <el-form-item
                    class="hydroware-other-checkbox hidden-sm hidden-md hidden-lg hidden-xl" 
                    prop="EMSCase" 
                    v-if="myController.Incident.EMS">
                    <el-input 
                        v-model="myController.Incident.EMSCase" 
                        :maxlength="30" 
                        placeholder="Enter EMS Case">
                    </el-input>
                </el-form-item>
            </div>
            <!--POLICE, FIRE DEPT, EMS FOR OTHER THAN XS-->
            <span
                v-if="myController.Incident.Police || myController.Incident.FireDepartment || myController.Incident.EMS">
                <!--POLICE-->
                <el-form-item
                    class="hydroware-other-checkbox hidden-xs col-sm-4"  
                    prop="PoliceCase">
                    <el-input 
                        v-bind:class="{'hydroware-ishidden': !myController.Incident.Police}"
                        v-model="myController.Incident.PoliceCase" 
                        :maxlength="30" 
                        placeholder=" Enter Police Dept. Case">
                    </el-input>
                </el-form-item>
                <!--FIRE DEPT-->
                <el-form-item 
                    class="hydroware-other-checkbox hidden-xs col-sm-4"  
                    prop="FireDepartmentCase">
                    <el-input 
                        v-bind:class="{'hydroware-ishidden': !myController.Incident.FireDepartment}"
                        v-model="myController.Incident.FireDepartmentCase" 
                        :maxlength="30" 
                        placeholder="Enter Fire Dept. Case">
                    </el-input>
                </el-form-item>
                <!--EMS-->
                <el-form-item 
                    class="hydroware-other-checkbox hidden-xs col-sm-4" 
                    prop="EMSCase">
                    <el-input
                        v-bind:class="{'hydroware-ishidden': !myController.Incident.EMS}"
                        v-model="myController.Incident.EMSCase" 
                        :maxlength="30" 
                        placeholder="Enter EMS Case">
                    </el-input>
                </el-form-item>
            </span>

<div class="col-xs-12">
                <el-form-item label="First aid administered:" prop="lastname">
                    <el-checkbox 
                        v-model="myController.Incident.FirstAidAdministered">
                    </el-checkbox>
                </el-form-item>
            </div>
            <div class="col-xs-12" v-if="myController.Incident.FirstAidAdministered">
                <el-form-item class="hydroware-other">
                    <el-input type="textarea" 
                        class="hydroware-no-resize-textarea"
                        v-model="myController.Incident.Treatment" 
                        :rows=2 
                        :maxlength="400" 
                        placeholder="What treatment was given">
                    </el-input>
                </el-form-item>
            </div>

<div class="col-xs-12">
                <el-form-item label="Advanced Medical Care:" prop="lastname">
                    <el-checkbox 
                        v-model="myController.Incident.AdvancedMedicalCare">
                    </el-checkbox>
                </el-form-item>
                <el-form-item class="hydroware-other">
                <el-input
                    placeholder="Name of medical facility" 
                    v-model="myController.Incident.AdvancedMedicalCarePlace"
                    :maxlength="30" 
                    v-if="myController.Incident.AdvancedMedicalCare">
                </el-input>
                </el-form-item>
                <el-form-item class="hydroware-other">
                <el-input 
                    placeholder="Additional information"
                    v-model="myController.Incident.AdvancedMedicalCareInformation" 
                    :maxlength="30"
                    v-if="myController.Incident.AdvancedMedicalCare">
                </el-input>
                </el-form-item>
            </div>

        <div class="col-lg-12 col-md-12">
            <div class="row">
                <h5 style="float:left;padding-left:10px;font-weight:700">
                    <span class="heading">
                        Victim(s)
                    </span>
                </h5>
                <div class="btn-group" style="float:right; margin-right:14px; ">
                    <button class="btn btn-white btn-sm"
                        v-bind:class="[{hydroware_hidden: $hydrowareSecurityJS.disableDataEntry_A('incidents',isAddingOrEditing)}]"  
                        onclick="return false;" 
                        @click="myController.addVictim()">
                        Add Victim
                    </button>
                </div>
            </div>
            <table 
                style="max-width:100%; overflow-x:auto;"
                class="hydroware-table table table-striped table-bordered table-hover gride TFtable">
                <thead class="hidden-md hidden-xs hidden-sm"><!--header does not display on smaller devices-->
                    <tr>
                        <th>
                            Name
                        </th>
                        <th>
                            Address
                        </th>
                        <th>
                            City
                        </th>
                        <th class="hydroware-state-column">
                            State
                        </th>
                        <th class="hydroware-zipcode-column">
                            Zip Code
                        </th>
                        <th class="hydroware-phonenumber-column">
                            Phone Number
                        </th>
                        <th class="hydroware-age-column">
                            Age
                        </th>
                        <th>
                            Activity
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="myController.Incident.IncidentVictimsList.length < 1 || myController.Incident.IncidentVictimsList == null"
                        class="" style="">
                        <td colspan="9" style="text-align:center;">
                            <h3>
                                <span
                                    style="font-weight: 700;opacity: 0.6;color:gray">
                                    {{myController.$hydrowareCommonJS.hydrowareMsgForNoData}}
                                </span>
                            </h3>
                        </td>
                    </tr>
                    <tr 
                        v-for="(item,index) in myController.Incident.IncidentVictimsList"
                        v-bind:key="item.Id">






<!--FG - FOOF - After Cert - First Release (7) - reworked this table to display nicely on smaller devices-->
                        <!--ON SMALLER DEVICES TWO DATA COLUMNS ARE DISPLAYED-->
                        <!--SMALLER DEVICES - COLUMN 1 -->
                        <td class="hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"><!--SMALLER DEVICES-->
                            <span class=hydroware-label-fixed>Name:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Name" 
                                :maxlength=30 
                                placeholder="Enter Name">
                            </el-input>
                            <div>
                            <span class=hydroware-label-fixed>Activity:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Activity" 
                                :maxlength=30 
                                placeholder="Enter Activity">
                            </el-input>                            
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>Phone #:</span>
                            <el-input class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.PhoneNumber" 
                                v-hydromask="'(###) ###-####'" 
                                placeholder="Enter Phone Number">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>Age:</span>
                            <el-input class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Age"
                                :maxlength=3 
                                v-hydromask="'###'" 
                                placeholder="Enter Age">
                            </el-input>
                            </div>
                        </td>
                        <!--END SMALLER DEVICES COLUMN 1-->
                        <!--COLUMN BELOW DISPLAYS ON SMALLER DEVICES - ADDRESS, STATE, ETC -->
                        <td class="hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"><!--SMALLER DEVICES-->
                            <span class=hydroware-label-fixed>Address:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Address" 
                                :maxlength=30 
                                placeholder="Enter Address">
                            </el-input>
                            
                            <div>
                            <span class=hydroware-label-fixed>City:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.City" 
                                :maxlength=30 
                                placeholder="Enter City">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>State:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.State" 
                                :maxlength=2 
                                placeholder="Enter State">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>Zip Code:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.ZipCode" 
                                :maxlength=10
                                placeholder="Enter Zip Code" 
                                v-hydromask="'#####-####'">
                            </el-input>
                            </div>            
                        </td>
                        <!--END SMALLER DEVICES COLUMN 2-->
                        <!--END SMALLER DEVICES COLUMNS-->





                        <!--LARGER DEVICES DISPLAY A COLUMN FOR EACH DATUM-->
                        <!--NAME LARGER DEVICES-->
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.Name" 
                                :maxlength=30 
                                placeholder="Name">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.Address" 
                                :maxlength=30 
                                placeholder="Address">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                              v-model="item.City" 
                              :maxlength=30 
                              placeholder="City">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                              v-model="item.State" 
                              :maxlength=30 
                              placeholder="State LARGE">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <!--
                            <input  
                                type="text" 
                                class="eltextcopy placeholder-class" 
                                v-model="item.ZipCode" 
                                placeholder="Enter Zip Code" 
                                v-mask="'############'" >
                            -->
                            <el-input  
                                type="text" 
                                v-model="item.ZipCode" 
                                placeholder="Enter Zip Code" 
                                v-mask="'############'" >
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <!--
                            <input type="text" 
                              class="eltextcopy placeholder-class" 
                              v-model="item.PhoneNumber" 
                              placeholder="Enter Phone" 
                              v-mask="'(###) ###-####'" >
                            -->
                            
                            <el-input  
                              v-model="item.PhoneNumber" 
                              placeholder="Enter Phone" 
                              v-hydromask="'(###) ###-####'" >
                            </el-input>
                            
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <!--
                            <input type="text" 
                              class="eltextcopy placeholder-class" 
                              v-model="item.Age" 
                              v-mask="'###'" 
                              placeholder="Enter Age">
                            -->
                             <el-input type="text" 
                              v-model="item.Age" 
                              v-mask="'###'" 
                              placeholder="Enter Age">
                             </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                              v-model="item.Activity" 
                              :maxlength=30 
                              placeholder="Enter Activity">
                            </el-input>
                        </td>
                        <td class="hydroware-1-button-column">
                            <button type="button" 
                              v-if="$hydrowareSecurityJS.canDelete_A('incidents')"
                              class="el-button el-button--danger el-button--small" 
                              title="" 
                              style="background-color: #ff4949!important;" 
                              @click="myController.removeVictim(index)">
                                <i class="el-icon-delete"
                                  style="color:white !important;">
                                </i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!--WITNESSES-->
        <div class="col-lg-12 col-md-12">
            <div class="row">
                <h5 style="float:left;padding-left:10px;font-weight:700">
                    <span class="heading">
                        Witness
                    </span>
                </h5>
                <div class="btn-group" 
                    style="float:right; margin-right:14px; ">
                    <button class="btn btn-white btn-sm"
                        v-bind:class="[{hydroware_hidden: $hydrowareSecurityJS.disableDataEntry_A('incidents',isAddingOrEditing)}]"  
                        onclick="return false;" 
                        @click="myController.addWitness()">
                           Add Witness
                    </button>
                </div>
            </div>
            <table style="max-width:100%; overflow-x:auto;"
                class="hydroware-table table table-striped table-bordered table-hover gride TFtable">
                <thead class="hidden-md hidden-xs hidden-sm">
                    <tr>
                        <th class="hidden-md hidden-xs hidden-sm">
                            Name
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm">
                            Address
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm">
                            City
                        </th>
                        <th  class="hidden-md hidden-xs hidden-sm hydroware-state-column">
                            State
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm hydroware-zipcode-column">
                            Zip Code
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm hydroware-phonenumber-column">
                            Phone Number
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm hydroware-age-column">
                            Age
                        </th>
                        <th></th>
                    </tr>
                </thead>
            <tbody>
                <tr v-if="myController.Incident.IncidentWitnessList.length < 1 || myController.Incident.IncidentWitnessList == null"
                    class="" style="">
                        <td colspan="8" style="text-align:center;">
                            <h3>
                                <span style="font-weight: 700;opacity: 0.6;color:gray">
                                    {{myController.$hydrowareCommonJS.hydrowareMsgForNoData}}
                                </span>
                            </h3>
                        </td>
                </tr>
                <tr 
                    v-for="(item,index) in myController.Incident.IncidentWitnessList"
                        v-bind:key="item.Id">
                        


<!--FG - FOOF - After Cert - First Release (7) - reworked this table to display nicely on smaller devices-->
                        <!--ON SMALLER DEVICES TWO DATA COLUMNS ARE DISPLAYED-->
                        <!--SMALLER DEVICES - COLUMN 1 -->
                        <td class="hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"><!--SMALLER DEVICES-->
                            <span class=hydroware-label-fixed>Name:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Name" 
                                :maxlength=30 
                                placeholder="Enter Name">
                            </el-input>
                            <div>
                            <span class=hydroware-label-fixed>Phone #:</span>
                            <el-input class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.PhoneNumber" 
                                v-hydromask="'(###) ###-####'" 
                                placeholder="Enter Phone Number">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>Age:</span>
                            <el-input class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Age"
                                :maxlength=3 
                                v-hydromask="'###'" 
                                placeholder="Enter Age">
                            </el-input>
                            </div>
                        </td>
                        <!--END SMALLER DEVICES COLUMN 1-->
                        <!--COLUMN BELOW DISPLAYS ON SMALLER DEVICES - ADDRESS, STATE, ETC -->
                        <td class="hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"><!--SMALLER DEVICES-->
                            <span class=hydroware-label-fixed>Address:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Address" 
                                :maxlength=30 
                                placeholder="Enter Address">
                            </el-input>
                            
                            <div>
                            <span class=hydroware-label-fixed>City:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.City" 
                                :maxlength=30 
                                placeholder="Enter City">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>State:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.State" 
                                :maxlength=2 
                                placeholder="Enter State">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>Zip Code:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.ZipCode" 
                                :maxlength=10
                                placeholder="Enter Zip Code" 
                                v-hydromask="'#####-####'">
                            </el-input>
                            </div>            
                        </td>
                        <!--END SMALLER DEVICES COLUMN 2-->
                        <!--END SMALLER DEVICES COLUMNS-->



                        <!--COLS BELOW DISPLAY ON LARGER DEVICES-->
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.Name" 
                                :maxlength=30 
                                placeholder="Enter Name">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.Address" 
                                :maxlength=30 
                                placeholder="Enter Address">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.City" 
                                :maxlength=30 
                                placeholder="Enter City">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.State" 
                                :maxlength=30 
                                placeholder="Enter State">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <!--
                            <input class="eltextcopy placeholder-class" 
                                type="number" placeholder="Enter Zip Code" 
                                v-model="item.ZipCode" 
                                maxlength="12" >
                            -->
                            <el-input 
                                type="number" placeholder="Enter Zip Code" 
                                v-model="item.ZipCode" 
                                maxlength="12" >
                            </el-input>
                       </td>
                       <td class="hidden-md hidden-xs hidden-sm">
                           <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <!--
                            <input type="text" 
                                class="eltextcopy placeholder-class" 
                                placeholder="Enter Phone Number" 
                                v-model="item.PhoneNumber" 
                                v-mask="'(###) ###-####'" >
                            -->
                            <el-input type="text" 
                                placeholder="Enter Phone Number" 
                                v-model="item.PhoneNumber" 
                                v-hydromask="'(###) ###-####'" >
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <!--
                            <input type="number" 
                                class="eltextcopy placeholder-class" 
                                placeholder="Enter Age" 
                                v-model="item.Age" 
                                maxlength="3">
                            -->
                            <el-input type="number" 
                                placeholder="Enter Age" 
                                v-model="item.Age" 
                                maxlength="3">
                            </el-input>
                        </td>
                        <td class="hydroware-1-button-column">
                            <button type="button" 
                                v-if="$hydrowareSecurityJS.canDelete_A('incidents')"
                                class="el-button el-button--danger el-button--small" 
                                title="" 
                                style="background-color: #ff4949!important;" 
                                @click="myController.removeWitness(index)">
                                    <i class="el-icon-delete"
                                        style="color:white !important;">
                                    </i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: ['myController', 'isAddingOrEditing']
  }
</script>                    


// WEBPACK FOOTER //
// accidentForm.vue?7d3fe51a